import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MeusVeiculosEditPageRoutingModule } from './meus-veiculos-edit-routing.module';
import { MeusVeiculosEditPage } from './meus-veiculos-edit.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    MeusVeiculosEditPageRoutingModule
  ],
  declarations: [MeusVeiculosEditPage]
})
export class MeusVeiculosEditPageModule {}
